<template>
  <div>
    <div>
      <div
        :style="{
          top: 'calc(3vh - 10px)',
          minWidth: '300px',
          right: '20px',
        }"
        class="s-popup-incoming animation-popup"
        :class="showModal ? 'active-popup' : ''"
      >
        <v-card class="text-center notice-custom">
          <v-card-title class="font-weight-bold mb-0">
            <div class="d-flex">
              <div class="mr-3 d-flex">
                <img src="./assets/createtask.svg" alt="" class="my-auto" />
              </div>
              <div class="w-full">
                <div class="content-notice">
                  <div class="my-auto">
                    <strong>{{task.title}}</strong>
                  </div>
                </div>
              </div>
            </div>
          </v-card-title>
          <v-card-text class="px-6 pt-0 pb-3">
            <div class="d-flex justify-center">
              <v-btn
                class="btn-show mr-2"
                small
                @click="openModal"
              >
                Xem chi tiết
              </v-btn>
              <v-btn
                class="btn-skip ml-2"
                small
                @click="closeModal"
              >
                Bỏ qua
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'noticeToDos',
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  created() {},
  beforeDestroy() {},

  methods: {
    openModal() {
      this.$emit('openModal');
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
/* eslint-enable */
</script>
<style lang="scss">
.btn-callcenter {
  float: right;
  margin: 0 !important;
  position: relative;
  top: -6px;
}
.float-right {
  float: right;
}
.v-card__actions {
  display: block;
  padding-bottom: 20px;
  overflow: hidden;
}
.v-card {
  overflow: hidden;
}
.popup-call {
  border: 1px solid #a9a9a9 !important;
}
.notice-custom {
  border-radius: 10px !important;
  border: none;
}
.btn-skip {
  background-color: transparent !important;
  box-shadow: none !important;
  .v-btn__content {
    color: #6C6C6C;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
  }
}
.btn-show {
  background-color: transparent !important;
  box-shadow: none !important;
  .v-btn__content {
    color: #CF246A;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
  }
}
.animation-popup {
  animation: fadeIn 0.5s;
  transform: translateX(calc(100% + 30px));
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.25, 1.35);
}
.active-popup {
  transform: translateX(0);
}
</style>
